import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import React from 'react'

//* typography
import {
  Header2,
  Header3,
  Header4,
  Header5,
  Header6,
} from '../src/components/global/typography/style'

//* utils
import formatInlineCode from '../src/utils/shortTextFormatting'
import { code, listItem, listStyle, paragraph, quoteBlock } from './utils/richText/elements'
import { embeddedEntry, inlineEmbeddedEntry } from './utils/richText/embedEntry'
import { entryHyperlink, hyperlink } from './utils/richText/hyperlinks'

const renderHeadingNode = (children: any) => {
  return children?.map((item: any) => <>{formatInlineCode(item)}</>)
}

const options = {
  renderNode: {
    [INLINES.ENTRY_HYPERLINK]: entryHyperlink,
    [INLINES.HYPERLINK]: hyperlink,
    [INLINES.EMBEDDED_ENTRY]: inlineEmbeddedEntry,
    [BLOCKS.EMBEDDED_ENTRY]: embeddedEntry,
    [BLOCKS.HEADING_2]: (_: any, children: any) => <Header2>{renderHeadingNode(children)}</Header2>,
    [BLOCKS.HEADING_3]: (_: any, children: any) => <Header3>{renderHeadingNode(children)}</Header3>,
    [BLOCKS.HEADING_4]: (_: any, children: any) => <Header4>{renderHeadingNode(children)}</Header4>,
    [BLOCKS.HEADING_5]: (_: any, children: any) => <Header5>{renderHeadingNode(children)}</Header5>,
    [BLOCKS.HEADING_6]: (_: any, children: any) => <Header6>{renderHeadingNode(children)}</Header6>,
    [BLOCKS.PARAGRAPH]: paragraph,
    [BLOCKS.UL_LIST]: listStyle,
    [BLOCKS.OL_LIST]: listStyle,
    [BLOCKS.LIST_ITEM]: listItem,
    [BLOCKS.QUOTE]: quoteBlock,
  },

  renderMark: {
    [MARKS.CODE]: code,
  },
}

export default options
